import { Fragment, memo } from 'react';

import Header from '@/components/Header/Header';

function NotFound() {
  return (
    <Fragment>
      <Header />

      <div className="container">Not Found</div>
    </Fragment>
  );
}

export default memo(NotFound);
